import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminParceiro: Routes = [
  {
    path: 'clientes',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CADASTRO',
      subMenuKey: 'PARTICIPANTES',
      module: 'PAR_CLIENTE',
      breadcrumb: {
        label: 'Clientes',
        icon: 'mdi mdi-account'
      },
      backend_path: '/clientes'
    },
    loadChildren: () =>
      import('@app/modules/cliente/cliente.module').then(m => m.ClienteModule)
  },
  {
    path: 'fornecedores',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CADASTRO',
      subMenuKey: 'PARTICIPANTES',
      module: 'PAR_FONECEDOR',
      breadcrumb: {
        label: 'Fornecedores',
        icon: 'mdi mdi-domain'
      },
      backend_path: '/fornecedores'
    },
    loadChildren: () =>
      import('@app/modules/fornecedor/fornecedor.module').then(
        m => m.FornecedorModule
      )
  },
  {
    path: 'fabricantes',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CADASTRO',
      subMenuKey: 'PARTICIPANTES',
      module: 'PAR_FABRICANTE',
      breadcrumb: { label: 'Fabricantes', icon: 'mdi mdi-office-building' }
    },
    loadChildren: () =>
      import('@modules/fabricantes/fabricantes.module').then(
        m => m.FabricantesModule
      )
  },
  {
    path: 'funcionarios',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CADASTRO',
      subMenuKey: 'PARTICIPANTES',
      module: 'PAR_FUNCIONARIO',
      breadcrumb: {
        label: 'Funcionários',
        icon: 'mdi mdi-account-supervisor-circle-outline'
      },
      backend_path: '/funcionarios'
    },
    loadChildren: () =>
      import('@app/modules/funcionario/funcionario.module').then(
        m => m.FuncionarioModule
      )
  },
  {
    path: 'vendedores',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CADASTRO',
      subMenuKey: 'PARTICIPANTES',
      module: 'PAR_VENDEDOR',
      breadcrumb: {
        label: 'Vendedores',
        icon: 'mdi mdi-account-multiple-outline'
      },
      backend_path: '/vendedores'
    },
    loadChildren: () =>
      import('@app/modules/vendedor/vendedor.module').then(
        m => m.VendedorModule
      )
  }
];
